const isPlanObject = (value) =>
  Boolean(
    value &&
      typeof value === "object" &&
      !Array.isArray(value) &&
      (value.name || value.code || value.pricing || value.limits || value.features)
  );

export const getSubscriptionRecord = (response) => {
  if (!response) return null;

  const payload =
    response.data && typeof response.data === "object" && !Array.isArray(response.data)
      ? response.data
      : response;

  const nested = payload.subscription && typeof payload.subscription === "object"
    ? payload.subscription
    : null;

  const plan = isPlanObject(payload.plan)
    ? payload.plan
    : isPlanObject(nested?.plan)
      ? nested.plan
      : null;

  const availablePlans = Array.isArray(payload.availablePlans)
    ? payload.availablePlans
    : Array.isArray(payload.plans)
      ? payload.plans
      : [];

  return {
    ...nested,
    ...payload,
    plan,
    availablePlans,
    ownerType: payload.ownerType || nested?.ownerType || "company",
    billingCycle:
      payload.billingCycle || nested?.billingCycle || plan?.billingCycle || "monthly",
  };
};

export const hasSubscriptionEnded = (subscription) => {
  const status = String(subscription?.status || "").toLowerCase();
  if (["expired", "ended", "inactive", "canceled", "cancelled"].includes(status)) {
    return true;
  }

  const endDate =
    subscription?.endDate ||
    subscription?.subscriptionEndDate ||
    subscription?.expiresAt ||
    subscription?.trialEndDate ||
    subscription?.nextBillingDate ||
    subscription?.nextBilling ||
    subscription?.billingDate ||
    subscription?.nextPaymentDate;
  const endTimestamp = endDate ? new Date(endDate).getTime() : NaN;

  return Number.isFinite(endTimestamp) && endTimestamp <= Date.now();
};

export const hasActiveSubscription = (subscription) => {
  if (!subscription || hasSubscriptionEnded(subscription)) return false;
  const status = String(subscription.status || "").toLowerCase();
  return status === "active" || status === "trial" || subscription.isActive === true;
};

export const formatSubscriptionDate = (value) => {
  if (value == null || value === "") return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export const getPlanPricing = (plan, type) => {
  const pricingList = plan?.pricing;
  if (!Array.isArray(pricingList) || pricingList.length === 0) return null;
  if (type) {
    const match = pricingList.find(
      (p) => String(p?.type || "").toLowerCase() === type.toLowerCase()
    );
    if (match) return match;
  }
  return pricingList[0];
};

const toNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

export const getUsageMetric = (subscription, keys) => {
  for (const key of keys) {
    const parts = key.split(".");
    let value = subscription;
    for (const part of parts) {
      value = value?.[part];
    }
    if (value != null && value !== "") return value;
  }
  return null;
};

export const buildUsageItem = ({
  used,
  limit,
  unit = "",
  suffix = "",
}) => {
  if (used == null && limit == null) {
    return { usedNum: 0, limitNum: 0, percent: 0, label: null };
  }

  const usedNum = toNumber(used);
  const limitNum = toNumber(limit);
  const percent =
    limitNum > 0 ? Math.min(100, Math.round((usedNum / limitNum) * 100)) : 0;
  const label =
    limitNum > 0
      ? `${usedNum}${unit} / ${limitNum}${unit}${suffix}`
      : `${usedNum}${unit}${suffix}`;

  return { usedNum, limitNum, percent, label };
};
